import { getFileTypeIcon } from "../lib/file-type-icon";
import {
  guessContentTypeFromFilename,
  middleTruncateFilename,
  resolveDocumentDisplayName,
  type DocumentOptions,
  type DocumentValue,
} from "./document-helpers";

export function DocumentCell({
  value,
  options,
}: {
  value: DocumentValue;
  options: DocumentOptions;
}) {
  const resolvedName = resolveDocumentDisplayName(value, options);
  if (!resolvedName) return null;

  const contentType = options.contentType ?? guessContentTypeFromFilename(resolvedName);
  const Icon = getFileTypeIcon(contentType);
  const truncated = middleTruncateFilename(resolvedName, 40);
  const onClick = options.onClick;
  const isClickable = !!onClick;

  const className = [
    "inline-flex min-w-0 items-center gap-1.5 rounded px-1 -mx-1 text-left text-sm",
    isClickable ? "cursor-pointer transition-colors hover:bg-muted/50" : "cursor-default",
  ].join(" ");

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!isClickable}
      className={className}
      title={resolvedName}
    >
      <Icon className="shrink-0 text-muted-foreground size-3.5" aria-hidden="true" />
      <span className="min-w-0 truncate">{truncated}</span>
    </button>
  );
}
